//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import {
  faBriefcase,
  faSmile,
  faLightbulb,
  faGraduationCap,
  faChessQueen,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faExternalLinkAlt,
} from '@fortawesome/pro-light-svg-icons';
import {
  maxLength,
  minLength,
} from 'vuelidate/lib/validators';

import api from '@motionelements/core/src/api/base-api-v2.js';

import AiToolsMixin from '@motionelements/core/src/components/mixins/ai-tools.mixin.js';

export default {
  name: 'VideoScriptwriter',
  mixins: [AiToolsMixin],
  components: {
    ToolLayout: () => import('@/components/core/ToolLayout.vue'),
    PromptTextarea: () => import('@/components/tools/PromptTextarea.vue'),
    SelectButtons: () => import('@/components/tools/SelectButtons.vue'),
    GenerateButton: () => import('@/components/tools/GenerateButton.vue'),
    ButtonLadda: () => import('@motionelements/core/src/components/ui/BaseButtonLadda.vue'),
  },
  head() {
    return {
      meta: [
        {
          name: '_foundr', // https://foundr.ai
          content: 'c0477ab43b13bb1fde31872a230260ef',
        },
      ],
    };
  },
  data() {
    return {
      demoHtml: '### Video Script\n\n**Scene 1:**\n<br><br>[Stock footage: airplane takeoff](https://www.motionelements.com/search/video?s=airplane+takeoff)\n\n<br><br>[Stock music: upbeat travel](https://www.motionelements.com/search/music?s=upbeat+travel)\n\n<br><br>**Voice-over:** "Welcome to Travel Tips with Jess!"\n\n***\n\n**Scene 2:**\n<br><br>[Stock footage: world map](https://www.motionelements.com/search/video?s=world+map)\n\n<br><br>[Stock music: inspirational beats](https://www.motionelements.com/search/music?s=inspirational+beats)\n\n<br><br>**Voice-over:** "Get ready to explore the world!"\n\n***\n\n**Scene 3:**\n<br><br>[Stock footage: packing suitcase](https://www.motionelements.com/search/video?s=packing+suitcase)\n\n<br><br>[Stock music: cheerful melody](https://www.motionelements.com/search/music?s=cheerful+melody)\n\n<br><br>**Voice-over:** "Subscribe for the best travel tips and tricks!"\n\n**End Screen:**\n<br><br>[Stock footage: airplane window](https://www.motionelements.com/search/video?s=airplane+window)\n\n<br><br>[Stock music: warm ending](https://www.motionelements.com/search/music?s=warm+ending)\n\n<br><br>**Voice-over:** "See you on the next adventure!"',
      demoHtmlInterval: null,
      isValid: null,
      maxDuration: 300,
      // maxDuration: 60,
      minDuration: 10,
      generatedHtml: '',
      isLoading: false,
      isStreaming: false,
      isCanceled: false,
      toneOfVoices: [
        {
          value: 'professional',
          title: this.$t('ai_scriptwriter.tone.professional'),
          icon: faBriefcase,
        },
        {
          value: 'friendly',
          title: this.$t('ai_scriptwriter.tone.friendly'),
          icon: faSmile,
        },
        {
          value: 'inspirational',
          title: this.$t('ai_scriptwriter.tone.inspirational'),
          icon: faLightbulb,
        },
        {
          value: 'educational',
          title: this.$t('ai_scriptwriter.tone.educational'),
          icon: faGraduationCap,
        },
        {
          value: 'authoritative',
          title: this.$t('ai_scriptwriter.tone.authoritative'),
          icon: faChessQueen,
        },
      ],
      form: {
        prompt: '',
        tone: 'friendly',
        duration: 10,
      },
      combineSplitData: '',
      combineLink: '',
      loadingLink: false,
    };
  },
  validations: {
    form: {
      prompt: {
        minLength: minLength(10),
        maxLength: maxLength(1000),
      },
    },
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn,
      isUserEmailVerified: state => state.user.member.emailVerified,
    }),
    externalIcon() {
      const icon = faExternalLinkAlt.icon;
      return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${icon[0]} ${icon[1]}" class="svg-inline--fa ml-1"><path fill="currentColor" d="${icon[4]}"></path></svg>`;
    },
    generatedHtmlWithLinks() {
      // pattern to transform string with [$linkText]($linkUrl) into html link
      const pattern = /\[([^\]]+)\]\(([^)]+)\)/g;

      return this.generatedHtml.replace(pattern, `[<a href="$2" target="_blank">$1 ${this.externalIcon}</a> ]`);
    },
    showCopyButton() {
      return false;
    },
    tool() {
      return this.aiTools.find(({ id }) => id === this.aiToolsIds.VIDEO_SCRIPTWRITER);
    },
    toolPrice() {
      return _.get(this.tool, 'price');
    },
  },
  methods: {
    validateDurationInput(event) {
      const value = +event.target.value;
      if (value > this.maxDuration) {
        event.target.value = this.maxDuration;
        this.form.duration = this.maxDuration;
      } else if (value < this.minDuration) {
        event.target.value = this.minDuration;
        this.form.duration = this.minDuration;
      } else {
        this.form.duration = Math.round(value);
      }
    },
    parseLink(value) {
      // if stream return link - add loading state with ... and set link to this.combineLink
      // first check of there is a link
      if (value.includes('(')) {
        this.loadingLink = true;
        this.combineLink += value;
        return false;
      }
      if (this.combineLink) {
        this.combineLink += value;
        // second check of there is a link
        if (!this.combineLink.includes('https')) {
          this.loadingLink = false;
          this.generatedHtml += this.combineLink;
          this.combineLink = '';
        }
        // after link is ended - add combineLink to generatedHtml and clear combineLink
        if (value.includes(')')) {
          this.loadingLink = false;
          this.generatedHtml += this.combineLink;
          this.generatedHtml += '<br><br>';
          this.combineLink = '';
        }
        return false;
      }

      return true;
    },
    parseValue(value) {
      try {
        const parsedValue = JSON.parse(value);
        const content = _.get(parsedValue, 'choices[0].delta.content', '');
        if (content && this.parseLink(content)) {
          if (this.generatedHtml && !this.generatedHtml.endsWith('<br><br>') && content.includes('[')) {
            this.generatedHtml += '<br><br>';
          }
          this.generatedHtml += content;
          if (content.includes(']') && !content.includes('](')) {
            this.generatedHtml += '<br><br>';
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    async generateAiScript() {
      if (!this.isLoggedIn) {
        this.$bvModal.show('sign-up-modal');
        return;
      }

      if (!this.isUserEmailVerified) {
        this.$bvModal.show('unverified-modal');
        return;
      }

      if (!this.form.prompt) {
        this.$refs.prompt.$refs.prompt.$refs.textarea.focus();
        return;
      }

      clearInterval(this.demoHtmlInterval);

      this.$v.form.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) return;

      if (!this.$v.form.$invalid) {
        this.isLoading = true;
        this.generatedHtml = '';

        this.isStreaming = true;
        const baseUrl = (process.env.VUE_APP_ENV === 'production' ? process.env.VUE_APP_API_URL : 'https://stage.motionelements.com');
        await fetch(`${baseUrl}/v2/scripts/generate?${new URLSearchParams({
          ...api.getLocaleParams(),
          ...this.form,
        })}`, {
          method: 'GET',
          headers: {
            Accept: 'text/event-stream',
          },
        })
          .then(async response => {
            this.isLoading = false;

            console.log(response);

            const reader = response.body.getReader();

            // eslint-disable-next-line no-constant-condition
            while (true) {
              // eslint-disable-next-line no-await-in-loop
              const { done, value } = await reader.read();
              if (done || this.isCanceled) {
                console.log('done', done);
                break;
              }

              const decoderValue = new TextDecoder().decode(value);

              const decoderValueArr = decoderValue.split('data: ');

              decoderValueArr.filter(value => !!value).map(value => {
                if (value.includes('DONE')) {
                  return;
                }
                // if the previous response doesn't end with "}", combine the 2 responses to parse them
                if (this.combineSplitData) {
                  this.combineSplitData += value;
                  this.parseValue(this.combineSplitData);
                  // clear combineSplitData after parse
                  this.combineSplitData = '';
                  return;
                }
                // if the data does not end with "}", set it to combineSplitData and wait for the next response.
                if (value.trim().slice(-1) !== '}') {
                  this.combineSplitData += value;
                  return;
                }
                this.parseValue(value);
              });
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.isCanceled = false;
            this.isLoading = false;
            this.isStreaming = false;
          });
      }
    },
    clearForm() {
      clearInterval(this.demoHtmlInterval);
      this.form.prompt = '';
      this.form.tone = 'friendly';
      this.form.duration = 10;
      this.generatedHtml = '';
    },
    cancelLoading() {
      this.generatedHtml = '';
      this.isCanceled = true;
      this.isLoading = false;
      this.isStreaming = false;
    },
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.generatedHtml);
      } catch ($e) {
        console.error($e);
      }
    },
    showDemoHtml() {
      this.form.prompt = 'Intro video for my YouTube channel about travel tips';
      const words = this.demoHtml.split(' ');
      let index = 0;
      this.demoHtmlInterval = setInterval(() => {
        if (index < words.length) {
          this.generatedHtml += words[index];
          // eslint-disable-next-line no-plusplus
          index++;
        } else {
          clearInterval(this.demoHtmlInterval);
        }
      }, 50);
    },
  },
  beforeDestroy() {
    clearInterval(this.demoHtmlInterval);
  },
  created() {
    this.showDemoHtml();
  },
};
